import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "new74",
  "use": "new74-usage",
  "viewBox": "0 0 55.79 60.44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 55.79 60.44\" id=\"new74\"><title>资源 39</title><g data-name=\"图层 2\"><path d=\"M53.51 2.31h-9.32V0h-7v2.31H18.63V0h-7v2.31H2.31A2.32 2.32 0 0 0 0 4.62v53.51a2.32 2.32 0 0 0 2.31 2.31h51.17a2.32 2.32 0 0 0 2.31-2.31V4.62a2.27 2.27 0 0 0-2.28-2.31zm-41.62 21l32.57-.2v4.66L11.92 28zm.11 9.32l32.57-.2v4.66l-32.57.2zm.07 14v-4.66l32.57-.2v4.66zm39.09-31.55H4.66v-2.77h46.5z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/new74.svg
// module id = XAkS
// module chunks = 6